import React from 'react';
import { IColorwayProductData, IVariant, TUserSelections } from '../../../types/PDP';
import { BopisContainer } from '../../Bopis/BopisContainer';
import styles from './style.module.scss';

const PickupInStoreTabPanel = ({
  selectedVariant,
  product,
  userSelections,
}: {
  selectedVariant: IVariant | undefined;
  quantityAvailable: number | undefined;
  product: IColorwayProductData;
  userSelections: TUserSelections;
}) => {
  return (
    <div className={styles.pickupInStoreTabPanel}>
      <BopisContainer
        selectedVariant={selectedVariant}
        product={product}
        userSelections={userSelections}
        shouldShowOmniPdpExperience={true}
      />
    </div>
  );
};

export default PickupInStoreTabPanel;
